import React from 'react';
import { expVal } from '@atlassian/jira-feature-experiments';
import {
	type DragAndDropProps,
	ContentWithDragAndDrop,
} from '@atlassian/jira-navigation-apps-sidebar-nav4-projects-customise-order/src/ui/project-menu-item/index.tsx';
import { componentWithCondition } from '@atlassian/jira-feature-flagging-utils';

export const Nav4ProjectMenuItemContent = componentWithCondition(
	() => expVal('blu-6314-drag-and-drop-projects-sidebar-experiment', 'isEnabled', false),
	ContentWithDragAndDrop,
	Content,
);

export type Nav4ProjectMenuItemContentProps = {
	renderMenuItem: (dragAndDropProps?: DragAndDropProps) => React.JSX.Element;
};

function Content({ renderMenuItem }: Nav4ProjectMenuItemContentProps) {
	return <>{renderMenuItem()}</>;
}
